import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Nav } from './components/Nav'
import { AnomalyBanner } from './components/AnomalyBanner'
import { Login } from './components/Login'
import { ToReview } from './pages/ToReview'
import { Matched } from './pages/Matched'
import { History } from './pages/History'
import { Health } from './pages/Health'
import { Omega } from './pages/Omega'
import { PayCom } from './pages/PayCom'
import { readSession } from './lib/auth'

export function App() {
  const [authed, setAuthed] = useState(false)

  useEffect(() => {
    setAuthed(readSession() !== null)
  }, [])

  if (!authed) return <Login onSignedIn={() => setAuthed(true)} />

  return (
    <BrowserRouter>
      <Nav />
      <AnomalyBanner />
      <main className="max-w-[1600px] mx-auto px-6 py-6">
        <Routes>
          <Route path="/" element={<ToReview />} />
          <Route path="/matched" element={<Matched />} />
          <Route path="/history" element={<History />} />
          <Route path="/health" element={<Health />} />
          <Route path="/omega" element={<Omega />} />
          <Route path="/paycom" element={<PayCom />} />
        </Routes>
      </main>
    </BrowserRouter>
  )
}
